export default {
    title: 'Massengenehmigung',

    selectProcesses: 'Bitte gehe in die Vorgangsübersicht, wähle dort die gewünschten Vorgänge aus und wähle dann das Werkzeug "Massengenehmigung" aus.',

    subsidyGrantedPercentageOfTotalCost: 'Bewilligt - % von Gesamtkosten',
    subsidyGrantedPercentageOfSubsidyRequested: 'Bewilligt - % von beantr. Zuschuss',
    fileReferenceNumberForAll: 'Aktenzeichen',
    subsidyGrantedAtForAll: 'Bewilligt am',
    forAll: 'Für alle übernehmen',
    approveAll: 'Alle genehmigen',
    rejectAll: 'Alle ablehnen',

    subsidyGranted: 'Bewilligt',
    fileReferenceNumber: 'Aktenzeichen',
    subsidyGrantedAt: 'Bewilligt am',

    saveSuccess: 'Die Vorgänge wurde erfolgreich gespeichert.',
}